export default __webpack_public_path__ + "static/media/lengkungatas.7a522549.png";